import { type ReactNode } from 'react';
import { useIsInProductContentFrame } from '@/shared/hooks/useIsInProductContentFrame';
import { cn } from '@/utils/tailwind.util';
import { FixedBottomFooter } from './FixedBottomFooter';
export interface MobileCTAFooterProps {
  children: ReactNode;
  /** 푸터 바로 위에 띄우는 문구(예: 잠긴 플랜 안내). */
  floatingText?: ReactNode;
}

/**
 * 모바일 전용 하단 고정 CTA. `tablet-sm` 이상에서는 숨고, 데스크톱 사이드 CTA 가 대신한다.
 * 퀴즈 상세와 폴더 상세가 함께 쓴다.
 */
export const MobileCTAFooter = ({
  children,
  floatingText
}: MobileCTAFooterProps) => {
  // 카드 안에서는 화면 고정 대신 카드 맨 아래 칸이 된다(카드 `footer` 로 넘긴다).
  const inFrame = useIsInProductContentFrame();
  return <FixedBottomFooter className={cn('border-t border-alternative bg-white px-md py-xs shadow-lg', inFrame ?
  // 카드 안에서는 흐름대로 두되 relative 로 둬, 위에 띄우는 문구(bottom-full)의 기준이 푸터가 되게 한다.
  'min-[769px]:relative min-[769px]:shrink-0 min-[769px]:shadow-none tablet-lg:hidden' : 'tablet-sm:hidden')} data-sentry-element="FixedBottomFooter" data-sentry-component="MobileCTAFooter" data-sentry-source-file="MobileCTAFooter.tsx">
      {!!floatingText && <div className="absolute inset-x-0 bottom-full" data-component="floating-text-wrapper">
          {floatingText}
        </div>}
      {children}
    </FixedBottomFooter>;
};